import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { RecommendedSizeByModificationType } from '../types/autoSelectsTypes';
import { RecommendedParamsApiDto } from './api.dto';

export const fetchRecommendedParamsByModification = async (query: RecommendedParamsApiDto): Promise<RecommendedSizeByModificationType> => {
  return await MyAxios.get(`/api/catalog/get-auto-recommended-params-by-modif?modificationId=${query.modification}&recMode=true`)
    .then(handleResponse)
    .catch(handleError);
};
